<div id="positionHeader">
    <span id="position-table-header" id="title" [ngClass]="{'section-title': !reviewConfirmationPage, 'subtitle': reviewConfirmationPage}">Positions</span>
</div>
<div id="errorBanners">
<mm-banners *ngIf="showSelectPositionError" [bannerText]="[selectPositionErrorText]" [type]="'error'"></mm-banners>
<mm-banners *ngIf="maxLotsWarning.displayWarning" [bannerText]="maxLotsWarningMessage" [titleText]="titleText"
    [type]="'error'"></mm-banners></div>
<mm-banners *ngIf="showSetToAverageMessageCounter > 0 && costBasisMethod !== 'FIFO'"
    [bannerText]="[setToAverageInformationText]" [type]="'information'" [showCloseIcon]="false"></mm-banners>
<mm-banners *ngIf="this.hasAnyQuantityMismatchPositions && !reviewConfirmationPage"
      [bannerText]="[positionMismatchDisclaimer]" [type]="'information'" [showCloseIcon]="false"></mm-banners>
<div id="position-lots-table" [class.big-bottom-spacer] = "!reviewConfirmationPage">
    <sdps-divider variation="secondary"></sdps-divider>
    <sdps-tabs sdps-id="position-lots-table-tabs" id="position-lots-table-tabs"></sdps-tabs>
    <div class="totalsHeader">
        <span class="totalsTab">Totals</span>
        <span class="totalsSpanVerticalLine">Positions <span class="lineBreak"></span> <span
                class="textStyle">{{positions}}</span></span>
        <span class="totalsSpan">Shares <span class="lineBreak"></span><span class="textStyle">{{shares}}</span></span>
        <span class="totalsSpan">Estimated market value <span class="lineBreak"></span><span
                class="textStyle ">{{emvFormatted}}</span> </span>
    </div>
    <sdps-divider variation="secondary"></sdps-divider>
    <ng-template [ngIf]="!displayTable$.getValue()">
        <sdps-divider variation="secondary"></sdps-divider>
        <div *ngIf="tableLoading$.getValue()" class='spinnerContainer'>
            <sdps-spinner type="loading" show-by-default="true"></sdps-spinner>
        </div>
        <div *ngIf="!tableLoading$.getValue()" class='errorMsgContainer'>
            <sdps-icon color="secondary" type="functional" name="warning" size="medium"></sdps-icon>
            <div class='message'>{{tableMessage}}</div>
        </div>
    </ng-template>
    <div *ngIf="displayTable$.getValue()">
        <div id="table-toolbar">
            <span id="table-info" class="sdps-text-body">
                <mm-total-results [displayedRows]="displayedRows"></mm-total-results>
                <span id="displayed-filter-count">{{this.numberOfFilters}} filter(s)
                    applied<button *ngIf="this.numberOfFilters > 0" class="clearAllButton" (click)="clearFilters($event)">
                        Clear all</button>
                    <span class="expandAll">
                        Expand all rows
                        <label class="switch">
                            <input type="checkbox" id="expandAllId" (click)="expandOrCollapse()" [disabled]="isInitiateAndReleaseFlowFromTable ? !this.isMasterDetail() : false">
                            <span class="slider round"></span>
                            <span class="labels" data-on="ON" data-off="OFF"></span>
                        </label>
                    </span>
                </span>
            </span>
            <span id="table-options">
                <mm-table-option [schwabIcon]="'download'" [text]="'Export'" (click)="exportTable()">
                </mm-table-option>
            </span>
        </div>
        <div>
            <ag-grid-angular class="sac-ag-grid ag-theme-material" [detailRowAutoHeight]="true"
                [getRowHeight]="getRowHeight" [gridOptions]="gridOptions" [rowData]="(rowData$ | async)"
                [columnDefs]="columnDefs" [defaultColDef]="defaultColumnDefs" [icons]="icons" [headerHeight]="35"
                [floatingFiltersHeight]="25" [components]="frameworkComponents" [sortingOrder]="sortingOrder"
                [pagination]="true" [paginationPageSize]="10" [suppressPaginationPanel]="true"
                [suppressMultiSort]="true" (gridReady)="onGridReady($event)" (filterChanged)="onFilterChanged($event)"
                [suppressDragLeaveHidesColumns]="true"
                domLayout="autoHeight"
                [noRowsOverlayComponent]="customErrorComponent" [noRowsOverlayComponentParams]="customErrorComponentParams"
                [suppressNoRowsOverlay]="true"
                [loadingOverlayComponent]="loadingOverlayComponent" [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                (columnMoved)="onColumnMoved($event)" [keepDetailRows]="true" (dragStopped)="onDragStopped($event)"
                [stopEditingWhenCellsLoseFocus]="true"
                [floatingFilter]="true" (cellValueChanged)="onPositionsCellValueChanged($event)"
                [rowSelection]="rowSelection" (rowSelected)="onRowSelect($event)" [suppressRowClickSelection]="true"
                [modules]="modules" [animateRows]="true" [masterDetail]="isInitiateAndReleaseFlowFromTable ? this.isMasterDetail() : true"
                [detailCellRendererParams]="detailCellRendererParams"
                [defaultExportParams]="defaultExportParams" [excelStyles]="excelStyles" >
            </ag-grid-angular>
            <mm-totals [gridApi]="gridApi" [sharesSelected]="displaytotalShared"
                [totalValue]="displaySelectedValue" [isReviewPage]="reviewConfirmationPage"></mm-totals>
            <mm-pagination [gridApi]="gridApi" (pageChanged)="onPageChanged()"></mm-pagination>
        </div>
        <sdps-divider variation="secondary"></sdps-divider>
        <div class="disclaimerMessage" data-testid="positions-lots-table_disclaimerMessage">
            <span class="disclaimerMessageText">Estimated market values shown are calculated at this moment in time and are subject to market changes and availability of securities while processing.</span>
        </div>
    </div>
</div>
